import { Component, HostListener, ViewChild, Input, OnInit, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ScriptsService} from '../../services/scripts.service';
import {SaleService} from '../../services/sale.service';
  import { GoogleAnalyticsService } from '../../../@core/utils/analytics.service';
import {SocketIncome} from '../../services/sockets'
 import * as CryptoJS from 'crypto-js';

import {  NbToastrService, NbGlobalPosition } from '@nebular/theme';

// Buying a key without leaving the page.
//
// The modal walks through four states: the form, the bank's page in a frame,
// a short wait while the webhook lands, and the code. It used to be a link that
// opened the bank in another tab, which left the buyer holding two windows and
// no idea which one to look at.
//
// Two independent things can end the wait - the socket, which is instant, and a
// poll of the order, which is slow but survives a dropped connection. Whichever
// arrives first wins; both routes end in the same place.
@Component({
  selector: 'app-payment-buy-code-modal',
  templateUrl: './payment-buy-code-modal.component.html',
  styleUrls: ['./payment-buy-code-modal.component.scss']
})
export class PaymentBuyCodeModalComponent implements OnInit, OnDestroy{


	@Input() stream:any = null
	@Input() playlist:any = null
	@Input() isPlaylist:boolean = false
	@Input() onCode:(code:string)=>Promise<boolean> = null
	unlocked = false
	closeIn = 0
	private static readonly CLOSE_AFTER_UNLOCK_S = 10
	private closeTimer:any = null

	loading:boolean = true
	// form | paying | waiting | done | failed
	state:string = 'form'
	error = false
	failMessage:string = ''
	dataLoader$:any = null
	email:string = ''
	phone:string = ''
	sockKey: any = null
	buyedCode: any = null
	orderId:string = ''
	payUrl:SafeResourceUrl = null
	rawPayUrl:string = ''

	// A payment that goes quiet inside the frame has no error to show: the bank is
	// mid-flow, or a card's 3-D Secure step is refusing to run in a third-party
	// frame, and from the outside both look identical to a blank rectangle. After
	// this long the modal offers the two ways out that do NOT leave the page:
	// paying from the monobank app, or opening the same invoice in its own window.
	private static readonly HELP_AFTER_MS = 100000
	showHelp = false
	private helpTimer:any = null

	private pollTimer:any = null
	private pollDeadline:number = 0
	private messageListener:any = null

	// How long the modal keeps asking about an order the buyer started. Past this
	// the letter and the SMS are the delivery, and the modal says so instead of
	// spinning forever.
	private static readonly POLL_EVERY_MS = 2500
	private static readonly POLL_FOR_MS = 4 * 60 * 1000


	constructor(protected ref: NbDialogRef<PaymentBuyCodeModalComponent>, private socket: SocketIncome,
	   private saleService: SaleService,     private toastrService: NbToastrService,
	   private sanitizer: DomSanitizer  ){

		this.sockKey = (new Date().getTime())+''+Math.random()


        }



	ngOnInit(){

		this.loading = false
		this.connectSocket()

		// The page the bank returns the payer to lives on our domain and says
		// "done" through postMessage. It is only a hint - the code still comes from
		// the socket or the poll - but it is what turns the frame into a wait
		// instead of leaving the bank's "thank you" sitting there.
		this.messageListener = (event:MessageEvent)=>{
			if(this.handleBankMessage(event)){ return }
			if(event.origin !== window.location.origin){ return }
			const data:any = event.data
			if(!data || data.source !== 'livestream-payment'){ return }
			if(this.state === 'paying'){ this.state = 'waiting'; this.clearHelpTimer() }
		}
		window.addEventListener('message', this.messageListener)
        }



   showToastCopyClipboard(text){

    this.toastrService.show('',text,{
      status: 'primary',
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }







  connectSocket(){

    this.socket.on('cmd', this.onCommand.bind(this))

    this.socket.on('connect', ()=>{
      this.socket.emit('onJoin',
       {
        sockKey: this.sockKey
        }
      )
    })

    this.socket.connect()
  }



  get isEnglish(){
  if(!this.stream?.publicIdentity){
    return false
  }

   return ['e017f1c0' , '43de735f' , 'aada46cb' , 'ccfabee3', '0432f141','0bbac3f1', '0d29511e', '8ab1af07', 'ced3e648','a7b77c92', '7900e957'].includes(this.stream.publicIdentity)

  }

   onCommand(data){

	if(data?.type === 'responseCode'){
		 if(data?.payload !== undefined){

			let code = data?.payload?.code

			if(code !== undefined){ this.finish(code) }
		}
 	  return
        }
 }



	get userEmail() {
	   return this.email ? CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.email)) : ''

	}


       get userPhone(){

		return this.phone  ? CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(this.phone)) : 'no'

       }


       emailChange(){

		this.error = false
		if(!this.isValidEmail){
			 this.error = true
		}
	}


	pay(){

		this.error = false

		if(!this.isValidEmail){
			this.error = true
			return
		}

		this.loading = true

		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}

		const request$ = this.isPlaylist
			? this.saleService.createPlaylistOrder(this.playlist?._id, this.email, this.phone, this.sockKey)
			: this.saleService.createSaleOrder(this.stream?.publicIdentity, this.email, this.phone, this.sockKey)

		this.dataLoader$ = request$.subscribe((data)=>{

			this.loading = false

			if(!data || !data.ok || !data.pageUrl){
				this.fail(data && data.message)
				return
			}

			this.orderId = data.orderId
			this.rawPayUrl = data.pageUrl
			this.payUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.pageUrl)
			this.state = 'paying'
			this.startPolling()
			this.startHelpTimer()

		}, (err)=>{
			this.loading = false
			// The refusal text the server wrote for the buyer, when there is one.
			this.fail(err?.error?.message)
		})

	}

	// Asks the order about itself until it is paid. Runs alongside the socket, not
	// instead of it: whichever answers first calls finish() and the other stops.
	private startPolling(){
		this.stopPolling()
		this.pollDeadline = Date.now() + PaymentBuyCodeModalComponent.POLL_FOR_MS

		this.pollTimer = setInterval(()=>{

			if(Date.now() > this.pollDeadline){
				this.stopPolling()
				// Whatever state the buyer is in, they get told. The old version only
				// spoke while 'waiting', so a payment window that never reported back
				// left the modal spinning silently forever.
				if(this.state !== 'done'){ this.fail(this.isEnglish
					? 'We have not received confirmation of the payment. If money was taken, the key will arrive by email.'
					: 'Ми не отримали підтвердження оплати. Якщо кошти списано, код надійде на email.') }
				return
			}

			if(!this.orderId){ return }

			this.saleService.getOrderStatus(this.orderId, this.sockKey).subscribe((res)=>{
				if(!res || !res.ok){ return }

				// Refunded while the buyer was still looking at the page. Saying nothing
				// and then promising a code by e-mail would be a lie.
				if(res.status === 'reversed'){
					this.fail(this.isEnglish
						? 'The payment was returned. Access has not been granted.'
						: 'Оплату повернено. Доступ не надано.')
					return
				}

				// Only a code ends the wait. A paid order whose code is not written yet
				// still reads as pending; treating it as done showed a success card with
				// an empty code and stopped the polling that would have fixed it.
				if(res.status === 'paid' && res.code){ this.finish(res.code) }
			}, ()=>{ /* a failed poll is not an error the buyer can act on */ })

		}, PaymentBuyCodeModalComponent.POLL_EVERY_MS)
	}

	private stopPolling(){
		if(this.pollTimer){ clearInterval(this.pollTimer); this.pollTimer = null }
	}

	private startHelpTimer(){
		this.clearHelpTimer()
		this.helpTimer = setTimeout(()=>{
			// Only while still on the bank's form. Once the payment reports back, or
			// fails outright, the hint would be noise.
			if(this.state === 'paying'){ this.showHelp = true }
		}, PaymentBuyCodeModalComponent.HELP_AFTER_MS)
	}

	private clearHelpTimer(){
		if(this.helpTimer){ clearTimeout(this.helpTimer); this.helpTimer = null }
		this.showHelp = false
	}


	private finish(code:string){
		this.stopPolling()
		this.clearHelpTimer()
		this.buyedCode = code
		this.loading = false
		this.state = 'done'
		if(typeof this.onCode === 'function'){
			Promise.resolve()
				.then(()=>this.onCode(String(code)))
				.then((ok)=>{
					this.unlocked = ok === true
					if(this.unlocked){ this.startCloseCountdown() }
				})
				.catch(()=>{ this.unlocked = false })
		}
	}

	private startCloseCountdown(){
		this.stopCloseCountdown()
		this.closeIn = PaymentBuyCodeModalComponent.CLOSE_AFTER_UNLOCK_S
		this.closeTimer = setInterval(()=>{
			this.closeIn--
			if(this.closeIn <= 0){
				this.stopCloseCountdown()
				this.closeMainModal()
			}
		}, 1000)
	}

	private stopCloseCountdown(){
		if(this.closeTimer){
			clearInterval(this.closeTimer)
			this.closeTimer = null
		}
	}

	private fail(message?:string){
		this.stopPolling()
		this.clearHelpTimer()
		this.loading = false
		this.failMessage = message || (this.isEnglish
			? 'Payment is unavailable right now.'
			: 'Оплата зараз недоступна.')
		this.state = 'failed'
	}

	// An escape hatch, not the main road: if a card's 3-D Secure step refuses to
	// run inside a frame, the same invoice opens in its own window and the modal
	// keeps waiting for the same order.
	openInWindow(){
		if(!this.rawPayUrl){ return }
		// A blocked popup returns null. Switching to "waiting" regardless left the
		// buyer staring at a spinner with no payment window anywhere on screen.
		const opened = window.open(this.rawPayUrl.replace('/frame/', '/'), '_blank')
		if(!opened){
			this.failMessage = this.isEnglish
				? 'The browser blocked the payment window. Allow pop-ups for this site, or pay in the form above.'
				: 'Браузер заблокував вікно оплати. Дозвольте спливаючі вікна або оплатіть у формі вище.'
			return
		}
		this.state = 'waiting'
	}

	private handleBankMessage(event:MessageEvent):boolean{
		let bankOrigin = ''
		try { bankOrigin = this.rawPayUrl ? new URL(this.rawPayUrl).origin : '' } catch(e){ bankOrigin = '' }
		if(!bankOrigin || event.origin !== bankOrigin){ return false }
		let data:any = event.data
		if(typeof data === 'string'){
			try { data = JSON.parse(data || '{}') } catch(e){ return true }
		}
		if(!data || typeof data !== 'object'){ return true }
		if(data.message === 'close-button' && this.state === 'paying'){
			this.backToForm()
		}
		if(data.message === 'monopay-link' && typeof data.value === 'string' && /^(https?|monobank):/i.test(data.value)){
			window.location.href = data.value
		}
		return true
	}

	backToForm(){
		this.stopPolling()
		this.clearHelpTimer()
		this.state = 'form'
		this.orderId = ''
		this.payUrl = null
		this.rawPayUrl = ''
	}



	get isValidEmail() {
	    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(String(this.email).toLowerCase());
	}


	closeMainModal(){
		this.ref.close()

	}






	ngOnDestroy(){
		this.stopCloseCountdown()
		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}

		this.stopPolling()
		this.clearHelpTimer()

		if(this.messageListener){
			window.removeEventListener('message', this.messageListener)
			this.messageListener = null
		}

		    this.socket.disconnect()
		    this.socket.removeAllListeners('cmd')
		    this.socket.removeAllListeners('connect')
	}



}
